const { userAgent: userAgentString } = navigator;

/**
 * A global namespace for `navigator.userAgent` string.
 */
const userAgent = userAgentString;
export default userAgent;
